/**
 * Default material recipe per cement bag — applied when owner picks a standard size.
 * Owner can override under Catalog → recipe fields.
 */
function withSandPerBag(entry) {
  const { sandPer1000Bricks, bricksPerCementBag, ...rest } = entry;
  const sandPerCementBag = parseFloat(((sandPer1000Bricks / 1000) * bricksPerCementBag).toFixed(3));
  return { ...rest, sandPer1000Bricks, bricksPerCementBag, sandPerCementBag };
}

export const FACTORY_BRICK_RECIPE_DEFAULTS = {
  '230×110×75 mm': withSandPerBag({ sandPer1000Bricks: 1.2, sandUnit: 'tonne', bricksPerCementBag: 400 }),
  '230×110×75 mm (hollow)': withSandPerBag({ sandPer1000Bricks: 0.9, sandUnit: 'tonne', bricksPerCementBag: 550 }),
  '230×110×65 mm': withSandPerBag({ sandPer1000Bricks: 1.0, sandUnit: 'tonne', bricksPerCementBag: 450 }),
  '230×110×65 mm (hollow)': withSandPerBag({ sandPer1000Bricks: 0.75, sandUnit: 'tonne', bricksPerCementBag: 600 }),
  '290×140×90 mm': withSandPerBag({ sandPer1000Bricks: 1.5, sandUnit: 'tonne', bricksPerCementBag: 300 }),
  '200×100×60 mm': withSandPerBag({ sandPer1000Bricks: 0.85, sandUnit: 'tonne', bricksPerCementBag: 500 }),
  '200×100×80 mm': withSandPerBag({ sandPer1000Bricks: 0.8, sandUnit: 'tonne', bricksPerCementBag: 350 }),
  'Standard interlocking paver': withSandPerBag({ sandPer1000Bricks: 0.7, sandUnit: 'tonne', bricksPerCementBag: 400 }),
  'Road curb stone': withSandPerBag({ sandPer1000Bricks: 2.0, sandUnit: 'tonne', bricksPerCementBag: 200 }),
};

export function recipeDefaultsForBrickSize(sizeLabel) {
  const key = String(sizeLabel || '').trim();
  return FACTORY_BRICK_RECIPE_DEFAULTS[key] || null;
}
